import z from "zod";

// download limits
export const MAX_AREA = 20_000 * 10_000; // 20 000 ha
export const MAX_NODES = 50;

// Zammad support ticket integration
export const MAX_ZAMMAD_ATTACHMENT_BYTES = 10 * 1024 * 1024; // 10 MB

const AVAILABLE_FEATURES = [
  "extraction",
  "property-search",
  "gis-connection",
] as const;
export const FEATURES = z
  .string()
  .transform((v) =>
    v
      .split(",")
      .map((s) => s.trim())
      .filter((s) => s.length > 0),
  )
  .pipe(z.enum(AVAILABLE_FEATURES).array())
  .readonly()
  .default(AVAILABLE_FEATURES)
  .parse((window as any).REALITY_FEATURES);
